// Axios instance para chamadas ao backend
import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || 'http://localhost:8000', // sem /api no fim (mais flexível)
  withCredentials: false,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  timeout: 15000,
})

export default http
